module.exports = "/_next/static/images/game-target-c21989c32eab9df1726e6c78f6f771f5.png";